import { useState } from 'react';
import { actionLabel } from '../operation/actionLabels';
import { LogViewer } from '../primitives/LogViewer';
import { excerptOf, linesOf } from '../primitives/logText';

/**
 * StepError (CO-150): a failed step's error as one quoted line — the tool's
 * own error, not the wrapper command — with the full output one click away
 * in a bounded log viewer, instead of a wall of text in the step list.
 */
export function StepError({ message, code }: { message: string; code?: string | null }) {
  const [open, setOpen] = useState(false);
  const excerpt = excerptOf(message);
  const multiline = message.length > excerpt.length + 20 || message.includes('\n');
  return (
    <div className="step-error" data-testid="step-error">
      <p className="step-error__excerpt">
        <span className="step-error__label">Error</span>
        <code translate="no">{excerpt}</code>
      </p>
      {multiline ? (
        <>
          <button type="button" className="link-button step-error__toggle" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
            {open ? actionLabel.hideDetails : actionLabel.viewDetails}
          </button>
          {open ? <LogViewer title="Output of this step" headingLevel={4} lines={linesOf(code ? `${code}: ${message}` : message, 'step')} maxHeight="short" /> : null}
        </>
      ) : null}
    </div>
  );
}
